/* eslint-disable camelcase */
import { BaseViewModel } from "@/models/core/BaseViewModel";
export class ServiceInHotel extends BaseViewModel {
  id: number = 0;
  name: string = "";
  selected = false;
  is_filter = false;
  is_point_filter = false;
}
